<template>
  <b-container>
    <b-row>
      <b-col cols="12">
        <b-row class="p-4">
          <div class="col-lg-6">
            <h4>پنل مدیریت منو ها</h4>
          </div>
          <div class="col-lg-6 text-left d-flex align-items-center justify-content-end">
            <data-import-manager class="ml-2" data-type="menu" @imported="getItems"/>
            <data-export class="ml-2" data-type="menu"/>
            <LanguageSelectBox @changeLanguage="getItems" module-name="menu" class="mx-4"/>
          </div>
        </b-row>
      </b-col>

      <b-row>
        <b-col cols="12" v-for="menuPosition in menuPositions" :key="menuPositions.indexOf(menuPosition)">
          <b-card no-body class="mb-1">
            <b-card class="menu-index-card p-0 shadow" block v-b-toggle="'collapse-'+menuPosition.value">
              <b-row class="w-100 p-0 m-0">
                <b-col class="set-font font-weight-bold">{{ menuPosition.text }}</b-col>
                <b-button
                    class="d-flex flex-column align-items-end border-0 bg-warning text-dark set-font font-weight-bold"
                    pill v-b-modal="menuPosition.value"
                    @click="setSelectMenuForm(menuPosition.value)">تغییر منو
                </b-button>

                <ChangeMenuModalForm
                    :menu-position="menuPosition"
                    :select-menu="selectMenu"
                    :select-options="selectOptions"
                    :menus="menus"
                />

              </b-row>
            </b-card>
            <b-collapse :id="'collapse-'+menuPosition.value" role="tabpanel">
              <b-row class="d-flex flex-row justify-content-center align-items-center w-100 p-0 m-0">
                <b-col cols="12" class="p-2 w-100" v-for="menu in menus" :key="menu.id"
                       v-if="menu.position===menuPosition.value && menu.status===1">
                  <b-row class="d-flex flex-row justify-content-center align-items-center border rounded p-1 m-0">
                    <b-col cols="8" class="d-flex flex-column align-items-start justify-content-center">
                      <span class="set-font">{{ menu.name }}</span>
                    </b-col>
                    <b-col cols="2" class="d-flex flex-column align-items-center justify-content-center">
                      <router-link :to="{name:'EditMenu', params:{id:menu.id}}">
                        <b-button class="set-font bg-info">
                          <b-icon icon="pen"/>
                        </b-button>
                      </router-link>
                    </b-col>
                    <b-col cols="2" class="d-flex flex-column align-items-center justify-content-center">
                      <b-button class="set-font bg-danger" @click="removeMenu(menu.id)">
                        <b-icon icon="trash"/>
                      </b-button>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
            </b-collapse>
          </b-card>
        </b-col>
      </b-row>

      <b-row class="pt-3">
        <b-row class="p-2 mt-3">
          <b-col><h6>لیست منوهای ساخته شده</h6></b-col>
        </b-row>
        <b-container class="shadow menu-container">
          <b-row class="d-flex flex-row justify-content-center align-items-center w-100 p-0 m-0">
            <b-col cols="12" class="p-0 pt-2 w-100" v-for="menu in menus" :key="menu.id">
              <b-row class="d-flex flex-row justify-content-center align-items-center border rounded p-1 m-0 zoom">
                <b-col cols="8" class="d-flex flex-column align-items-start justify-content-center">
                  <span class="set-font">{{ menu.name }}</span>
                </b-col>
                <b-col cols="2" class="d-flex flex-column align-items-center justify-content-center">
                  <router-link :to="{name:'EditMenu', params:{id:menu.id}}">
                    <b-button class="set-font bg-info">
                      <b-icon icon="pen"/>
                    </b-button>
                  </router-link>
                </b-col>
                <b-col cols="2" class="d-flex flex-column align-items-center justify-content-center">
                  <b-button class="set-font bg-danger" @click="removeMenu(menu.id)">
                    <b-icon icon="trash"/>
                  </b-button>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </b-container>
      </b-row>
    </b-row>

    <b-row class="add-menu-btn-container">
      <b-button class="add-menu-btn p-2 rounded-circle shadow bg-info" v-b-modal.modal>
        <b-icon icon="plus" class="m-0 p-0 text-dark"/>
      </b-button>
    </b-row>

    <b-modal id="modal" ref="modal" centered scrollable hide-header-close
             title="ایجاد منو جدید" header-bg-variant="dark"
             header-text-variant="light" @ok="onSubmit">

      <form @submit.stop.prevent="onSubmit">
        <form-group :validations="$v.newMenu.name">
          <div slot-scope="{ errors, invalid }">
            <b-form-input type="text" v-model="newMenu.name" placeholder="عنوان منو"/>
            <form-errors-manager :errors="errors"/>
          </div>
        </form-group>

        <form-group :validations="$v.newMenu.language_id">
          <div slot-scope="{ errors, invalid }">
            <select class="my-4 custom-select" v-model="newMenu.language_id">
              <option value="">انتخاب زبان</option>
              <option v-for="language in languages" :value="language.id">{{ language.name }}</option>
            </select>
            <form-errors-manager :errors="errors"/>
          </div>
        </form-group>

        <form-group :validations="$v.newMenu.background">
          <div slot-scope="{ errors, invalid }">
            <b-form-input type="color" v-model="newMenu.background"/>
            <form-errors-manager :errors="errors"/>
          </div>
        </form-group>
      </form>

      <template #modal-footer="{ ok, cancel}">
        <b-row class="d-flex flex-row justify-content-around w-100">
          <b-button size="md" variant="success" @click="ok()">
            اضافه کردن آیتم
          </b-button>
          <b-button size="md" variant="danger" @click="cancel()">
            انصراف
          </b-button>
        </b-row>
      </template>
    </b-modal>

  </b-container>
</template>

<script>
import {mapGetters} from "vuex";
import FormGroup from "../../components/validator/FormGroup";
import {required, minLength, maxLength, numeric} from "vuelidate/lib/validators";
import FormErrorsManager from '../../components/validator/FormErrorsManager.vue'
import ChangeMenuModalForm from "../../components/dashboard/menu/ChangeMenuModalForm";
import LanguageSelectBox from "../../components/dashboard/Language/LanguageSelectBox";
import DataImportManager from "../../components/dashboard/DataImport/DataImportManager.vue";
import DataExport from "../../components/dashboard/DataExport/DataExport.vue";

export default {
  name: "Menus",
  components: {DataExport, DataImportManager, FormGroup, FormErrorsManager, ChangeMenuModalForm, LanguageSelectBox},
  data() {
    return {
      menuPositions: [
        {text: 'منو اصلی فروشگاه', value: 'store_nav'},
        {text: 'منو فوتر سایت', value: 'store_footer'},
        {text: 'منو اصلی وبلاگ', value: 'blog_nav'},
        {text: 'منو فوتر وبلاگ', value: 'blog_footer'}],
      newMenu: {
        status: false,
        position: null,
        name: '',
        language_id: '',
        background: '#FFFFFF'
      },
      selectMenu: {position: null, menu_id: null},
      selectOptions: []
    }
  },
  validations: {
    newMenu: {
      status: {required},
      background: {required},
      language_id: {required},
      name: {required},
    }
  },
  computed: {
    ...mapGetters({
      menus: "Menu/getAllMenus",
      languages: 'Language/getLanguages'
    })
  },
  methods: {
    handleOk(form) {
      this.$store.dispatch("Menu/createMenu", form)
    },
    removeMenu(menuId) {
      let text = "آیا از حذف منو اطمینان دارید؟";
      if (confirm(text) === true) {
        this.$store.dispatch("Menu/deleteMenu", menuId)
      }
    },
    setSelectMenuForm(positionValue) {
      let options = []
      this.menus.forEach(element => (options.push({text: element.name, value: element.id})))

      this.selectOptions = options
      this.selectMenu.position = positionValue
    },
    resetSelectMenu() {
      this.selectMenu = {position: null, menu_id: null}
    },
    invalid() {
      this.$v.$touch();
      return !this.$v.$invalid;
    },
    onSubmit(bvModalEvent) {
      bvModalEvent.preventDefault()
      if (this.invalid()) {
        let form = this.newMenu
        this.handleOk(form);
        this.$nextTick(() => {
          this.$bvModal.hide('modal')
        })
      }
    },
    getItems() {
      this.$store.dispatch("Menu/getMenus")
    }
  },
  mounted() {
    this.getItems();
  }
}
</script>

<style scoped>
.set-font {
  font-size: 12px;
}

.add-menu-btn {
  width: 50px;
  height: 50px;
  position: fixed;
  bottom: 30px;
}

.add-menu-btn-container {
  position: absolute;
  width: max-content;
  right: 30px;
  bottom: 30px;
}

.menu-container {
  margin-top: 30px;
  height: 400px;
  overflow-y: scroll;
}

.menu-index-card .card-body {
  padding: 5px;
  width: 100%;
  border: none;
}

.menu-index-card {
  border: none;
}
</style>